// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_CancelarCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /compromissos/cancelar_compromisso/{id}
 *
 * Cancels an appointment and reverts its services to "Aguardando".
 * Action endpoint with no payload — the controller signals success via the
 * envelope's `success` flag and emits `dados: null`. The `null` PHP type
 * (PHP 8.2+) makes the no-data shape explicit so it is justified, not
 * erased, and preserves the `Dados = null` shape downstream in TypeScript.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_CancelarCompromissoResponseDados = null;

export type Compromissos_CancelarCompromissoResponse = ApiResponse<Compromissos_CancelarCompromissoResponseDados>;

registerResponseContract('Compromissos_CancelarCompromissoResponse', {})
